var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.shouldUseNewCollectionPage)?_c(_setup.ExpandedCollectionPage):_c(_setup.BasicCollectionPage)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }